import { qsa, add, remove } from "@fluorescent/dom";
import { shouldAnimate, delayOffset } from "@/lib/animation";

const selectors = {
  flyouts: ".collection-flyout",
  animationItems: ".collection-flyout__content, .collection-flyout__footer",
};

export default node => {
  if (!shouldAnimate(node)) return;
  const flyouts = qsa(selectors.flyouts, node);
  flyouts.forEach(flyout => {
    delayOffset(flyout, [selectors.animationItems], 1);
  });
};
